import { render, staticRenderFns } from "./IbxItem.vue?vue&type=template&id=e06e3cc6"
import script from "./IbxItem.vue?vue&type=script&lang=js"
export * from "./IbxItem.vue?vue&type=script&lang=js"
import style0 from "./IbxItem.vue?vue&type=style&index=0&id=e06e3cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports